import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';




class Greeting extends React.Component {
    render() {
        return (
        <div>
            <div id="firstView">
                <p>You can use this simple app to take a good look at your feelings and fears and possibly work through them. It walks you through a technique called 
                    Cognative Behavioral Therapy, which is used by therapists to help people rationalize past their worries and other types of distress.
                    While this app may very well help you in a pinch, please keep in mind that it is not meant to replace treatment by a professional. 
                    With that in mind, let's start with a quick introduction: what's your name?</p>
                <form onSubmit={this.props.handleFirstSubmit}>
                    <label>
                        My Name Is:<br />
                        <input required
                            name="username"
                            value={this.props.username}
                            placeholder="Name"
                            onChange={this.props.handleChange} />
                        </label>
                    <input type="submit" value="Submit" className="padLeft" />
                </form>
            </div>
                <p id="greeting" className="result"></p>
        </div>
        );
    }
}

class FirstForm extends React.Component {
    render() {
        return (
            <div id="partOne">
            <div id="formOne">
                <form onSubmit={this.props.handleSecondSubmit}>
                    <label>
                        What are you concerned about right now?<br /> 
                        <textarea required
                            value={this.props.worry}
                            cols="60"
                            rows="10"
                            name="worry"
                            placeholder="Describe it here."
                            onChange={this.props.handleChange} />
                    </label>
                    <br />
                    <label>
                        What emotions are you having as a result? <br />
                        <textarea required
                            value={this.props.feelings}
                            cols="60"
                            rows="10"
                            name="feelings"
                            placeholder="List some emotions here."
                            onChange={this.props.handleChange} />
                    </label>
                    <br />
                    <label>
                        On a scale of 1 to 10, with 10 being the most intense, how strong are these feelings? <br />
                    <input required
                        value={this.props.intensity}
                        type="number"
                        name="intensity"
                        placeholder="1"
                        min="1"
                        max="10"
                        onChange={this.props.handleChange} />
                    </label>
                    <br />
                    <input type="submit" value="Submit" />
                </form>
            </div>
            <p id="resultsOne" className="result"></p>
        </div>
        );
    }
}

class SecondForm extends React.Component {
    render() {
        return (
            <div id="partTwo">
                <div id="lastForm">
                <form onSubmit={this.props.handleThirdSubmit}>
                    <label>
                        What proof do you have that your worry, belief or concern won't come true or that it may not be rational? <br />
                        <textarea required
                            cols="60"
                            rows="10"
                            placeholder="List your evidence."
                            name="proof"
                            onChange={this.props.handleChange} />
                    </label>
                    <br />
                    <label>
                        Think back to your original feelings. How would you rank their intensity now? <br />
                        <input required
                            value={this.props.newIntensity}
                            type="number"
                            placeholder="1"
                            name="newIntensity"
                            min="1"
                            max="10"
                            onChange={this.props.handleChange} />
                        </label>
                    <br />
                    <label>
                        What emotions are you feeling now? <br/>
                        <textarea required
                            name="newFeelings"
                            cols="60"
                            rows="10"
                            placeholder="List your new emotions here."
                            onChange={this.props.handleChange} />
                    </label>
                    <br />
                    <label>
                        On a scale of 1 to 10, how intensely are you feeling these new emotions? <br/>
                        <input required
                            type="number"
                            placeholder="1"
                            min="1"
                            max="10"
                            name="finalIntensity"
                            onChange={this.props.handleChange}/>
                    </label>
                    <br />
                    <input type="submit" value="Submit" />
                </form>
                </div>
                <br />
                <p id="review"></p>
                <p id="verdict"></p>
                <p id="currentFeeling"></p>
                <p id="final"></p>

            </div>
        );
    }
}



class Cognative extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            worry: '',
            feelings: '',
            intensity: '',
            proof: '',
            newIntensity: '',
            newFeelings: '',
            finalIntensity: ''
        };

    this.handleChange = this.handleChange.bind(this);
    this.handleFirstSubmit = this.handleFirstSubmit.bind(this);
    this.handleSecondSubmit = this.handleSecondSubmit.bind(this);
    this.handleThirdSubmit = this.handleThirdSubmit.bind(this);
}

handleChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
        [name]: value
    });
}

handleFirstSubmit(event) {
    document.getElementById('greeting').innerHTML = 'Hi, ' + this.state.username + '!' + ' ' + 'Nice to meet you.' + ' Shall we begin?';
    document.getElementById('firstView').classList.add('hideMe');
    document.getElementById('partOne').classList.add('showMe');
    event.preventDefault();
}

handleSecondSubmit(event) {
    window.scrollTo(0,0);
    document.getElementById('resultsOne').innerHTML = this.state.username + ',' + ' it looks like you are worried about the following: ' + this.state.worry + '.' + '<br />' + ' As a result, you are feeling the following emotions: ' + this.state.feelings + '.' +
     '<br />' + ' You would rank the intensity of your emotions at ' + this.state.intensity + ' out of 10. Maybe we can help you feel a bit better?';
    document.getElementById('greeting').classList.add('hideMe');
    document.getElementById('formOne').classList.add('hideMe');
    document.getElementById('partTwo').classList.add('showMe');
    event.preventDefault();
}

handleThirdSubmit(event) {
        window.scrollTo(0,0);
        document.getElementById('resultsOne').classList.add('hideMe');
        document.getElementById('lastForm').classList.add('hideMe');
        document.getElementById('review').innerHTML = this.state.username + ',' + ' let\'s look at your progress. You were concerned about ' + this.state.worry + ' and it made you feel the following emotions: ' + this.state.feelings + '.' + ' You initially ranked the intensity of your emotions at ' + this.state.intensity +' out of 10. After coming up with evidence against your concern, you then ranked the intensity of your emotions at ' + this.state.newIntensity + ' out of 10.';
        if (this.state.intensity < this.state.newIntensity) {
            document.getElementById('verdict').innerHTML = 'It looks like you are feeling a lot better!';
        } else if (this.state.intensity > this.state.newIntensity) {
            document.getElementById('verdict').innerHTML = 'It looks like you are feeling worse than you did before. Maybe this app isn\'t helpful to you. It may be a good idea to contact your psychologist/psychiatrist/therapist if you feel unsafe. We hope you feel better soon!';
        } else if (this.state.intensity === this.state.newIntensity) {
            document.getElementById('verdict').innerHTML = 'It looks like you feel about the same now as you did before. It might help to run through this app one more time to see if your mood improves. If you feel unsafe, then it may be wise to contact your psychiatrist/psychologist/therapist. We hope you feel better soon!';
        }
        document.getElementById('currentFeeling').innerHTML = 'Right now, you are experiencing the following emotions: ' + this.state.newFeelings + ' and would rank their intensity at ' + this.state.finalIntensity + ' out of 10.';
        document.getElementById('final').innerHTML = 'I hope that this process helped you. Best wishes! - Lindsey Johnson, App Developer';
        event.preventDefault();
}



render() {
    return (
       <div className="Parent">
           <h1>Welcome to Untngl</h1>
           <Greeting
           handleChange={this.handleChange}
           handleFirstSubmit={this.handleFirstSubmit} />
           <FirstForm
           handleChange={this.handleChange}
           handleSecondSubmit={this.handleSecondSubmit} />
           <SecondForm
           handleChange={this.handleChange}
           handleThirdSubmit={this.handleThirdSubmit}  />
       </div> 
    );
  }
}



ReactDOM.render(
    <Cognative />,
    document.getElementById('root')
);